module.exports = __webpack_public_path__ + "static/img/banner18.df135acc.png";